import React, { useEffect, useState } from 'react';
import { Result, Spin, Button, Typography } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

const Unsubscribe = () => {
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No unsubscribe token found in the link.');
      return;
    }
    axios.get(`/api/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(res => {
        setStatus('success');
        setMessage(res.data.email ? `${res.data.email} has been unsubscribed.` : 'You have been unsubscribed.');
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.message || 'The unsubscribe link is invalid or has expired.');
      });
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
      padding: 24,
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '48px 40px',
        maxWidth: 480,
        width: '100%',
        boxShadow: '0 8px 40px rgba(0,0,0,0.08)',
        textAlign: 'center',
      }}>
        {status === 'loading' && (
          <>
            <Spin size="large" style={{ marginBottom: 24 }} />
            <div><Text style={{ color: '#6b7280' }}>Processing your request…</Text></div>
          </>
        )}

        {status === 'success' && (
          <Result
            icon={<CheckCircleOutlined style={{ color: '#10b981', fontSize: 56 }} />}
            title="You've been unsubscribed"
            subTitle={<Text style={{ color: '#6b7280' }}>{message}</Text>}
            extra={
              <Text style={{ color: '#9ca3af', fontSize: 13 }}>
                You won't receive any more emails from us.<br />
                Changed your mind?{' '}
                <a href="mailto:support@example.com" style={{ color: '#0a40d9' }}>Contact us</a>.
              </Text>
            }
          />
        )}

        {status === 'error' && (
          <Result
            icon={<CloseCircleOutlined style={{ color: '#ef4444', fontSize: 56 }} />}
            title="Unsubscribe failed"
            subTitle={<Text style={{ color: '#6b7280' }}>{message}</Text>}
            extra={
              <Button type="primary" onClick={() => navigate('/login')} style={{ borderRadius: 8 }}>
                Go to Login
              </Button>
            }
          />
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;
